<!-- Backdrop -->
<div class="help-drawer-backdrop" [class.open]="isOpen" (click)="close()"></div>

<!-- Drawer -->
<div class="help-drawer" [class.open]="isOpen">
  <!-- Header -->
  <div class="help-header">
    <div class="header-content">
      <button *ngIf="currentArticle && !helpService.activeTour" mat-icon-button (click)="goBack()" class="back-btn">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <button *ngIf="helpService.activeTour" mat-icon-button (click)="endTour()" class="back-btn">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <h2>{{ helpService.activeTour ? helpService.activeTour.name : (currentArticle ? currentArticle.title : 'Help Center') }}</h2>
    </div>
    <button mat-icon-button (click)="close()" class="close-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="help-content">
    <!-- Active Tour View -->
    <ng-container *ngIf="helpService.activeTour">
      <div class="tour-view">
        <div class="tour-header-badge">
          <mat-icon>tour</mat-icon>
          <span>{{ helpService.activeTour.name }}</span>
        </div>

        <!-- Step progress -->
        <div class="tour-progress">
          <div class="tour-progress-bar">
            <div class="tour-progress-fill" [style.width.%]="((helpService.activeTourStep + 1) / helpService.activeTour.steps.length) * 100"></div>
          </div>
          <span class="tour-progress-text">Step {{ helpService.activeTourStep + 1 }} of {{ helpService.activeTour.steps.length }}</span>
        </div>

        <!-- Step card -->
        <div class="tour-step-card">
          <div class="tour-step-number">{{ helpService.activeTourStep + 1 }}</div>
          <h3 class="tour-step-title">{{ helpService.activeTour.steps[helpService.activeTourStep].title }}</h3>
          <p class="tour-step-content">{{ helpService.activeTour.steps[helpService.activeTourStep].content }}</p>
        </div>

        <!-- Steps overview -->
        <div class="tour-steps-overview">
          <div class="tour-step-dot" *ngFor="let step of helpService.activeTour.steps; let i = index"
               [class.active]="i === helpService.activeTourStep"
               [class.completed]="i < helpService.activeTourStep"
               (click)="helpService.activeTourStep = i">
            <div class="dot-circle">
              <mat-icon *ngIf="i < helpService.activeTourStep">check</mat-icon>
              <span *ngIf="i >= helpService.activeTourStep">{{ i + 1 }}</span>
            </div>
            <span class="dot-label">{{ step.title }}</span>
          </div>
        </div>

        <!-- Navigation buttons -->
        <div class="tour-nav">
          <button mat-stroked-button (click)="endTour()">Exit Tour</button>
          <div class="tour-nav-right">
            <button mat-stroked-button (click)="prevStep()" [disabled]="helpService.activeTourStep === 0">
              <mat-icon>chevron_left</mat-icon> Back
            </button>
            <button mat-flat-button color="primary" *ngIf="helpService.activeTourStep < helpService.activeTour.steps.length - 1" (click)="nextStep()">
              Next <mat-icon>chevron_right</mat-icon>
            </button>
            <button mat-flat-button color="primary" *ngIf="helpService.activeTourStep === helpService.activeTour.steps.length - 1" (click)="endTour()">
              <mat-icon>check_circle</mat-icon> Finish
            </button>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Main View (no article selected, no tour active) -->
    <ng-container *ngIf="!currentArticle && !helpService.activeTour">
      <!-- Search -->
      <div class="search-section">
        <mat-form-field appearance="outline" class="search-field">
          <mat-icon matPrefix>search</mat-icon>
          <input matInput placeholder="Search help articles..." [ngModel]="searchQuery" (ngModelChange)="onSearch($event)">
          <button *ngIf="searchQuery" mat-icon-button matSuffix (click)="clearSearch()">
            <mat-icon>clear</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- Search Results -->
      <div *ngIf="searchQuery && searchResults.length > 0" class="search-results">
        <h3>Search Results ({{ searchResults.length }})</h3>
        <div class="article-card" *ngFor="let article of searchResults" (click)="openArticle(article)">
          <div class="article-title">{{ article.title }}</div>
          <div class="article-category">
            <mat-icon>{{ getCategoryIcon(article.category) }}</mat-icon>
            {{ getCategoryName(article.category) }}
          </div>
        </div>
      </div>

      <!-- No results -->
      <div *ngIf="searchQuery && searchResults.length === 0" class="no-results">
        <mat-icon>search_off</mat-icon>
        <p>No articles found for "{{ searchQuery }}"</p>
      </div>

      <!-- Default view (no search) -->
      <ng-container *ngIf="!searchQuery">
        <!-- Quick Start Tours -->
        <div class="quick-start-section">
          <h3><mat-icon>rocket_launch</mat-icon> Quick Start Tours</h3>
          <div class="tour-cards">
            <div class="tour-card" *ngFor="let tour of visibleTours" (click)="startTour(tour)">
              <div class="tour-icon">
                <mat-icon>tour</mat-icon>
              </div>
              <div class="tour-info">
                <div class="tour-name">{{ tour.name }}</div>
                <div class="tour-desc">{{ tour.description }}</div>
              </div>
              <mat-icon class="tour-arrow">arrow_forward</mat-icon>
            </div>
          </div>
        </div>

        <!-- Categories -->
        <div class="categories-section">
          <h3><mat-icon>folder</mat-icon> Browse by Category</h3>
          <mat-accordion>
            <mat-expansion-panel *ngFor="let category of visibleCategories">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>{{ category.icon }}</mat-icon>
                  {{ category.name }}
                </mat-panel-title>
                <mat-panel-description>
                  {{ getArticleCount(category.id) }} articles
                </mat-panel-description>
              </mat-expansion-panel-header>

              <div class="category-articles">
                <div class="article-item" *ngFor="let article of getArticles(category.id)" (click)="openArticle(article)">
                  <mat-icon>article</mat-icon>
                  <span>{{ article.title }}</span>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </ng-container>
    </ng-container>

    <!-- Article View -->
    <ng-container *ngIf="currentArticle && !helpService.activeTour">
      <div class="article-view">
        <div class="article-meta">
          <span class="category-chip">
            <mat-icon>{{ getCategoryIcon(currentArticle.category) }}</mat-icon>
            {{ getCategoryName(currentArticle.category) }}
          </span>
        </div>

        <div class="article-body" [innerHTML]="getRenderedArticleContent(currentArticle) | markdown"></div>

        <div *ngIf="currentArticle.relatedArticles && currentArticle.relatedArticles.length" class="related-articles">
          <h4>Related Articles</h4>
          <ng-container *ngFor="let relatedId of currentArticle.relatedArticles">
            <div class="related-item" *ngIf="getArticleById(relatedId) as related" (click)="openArticle(related)">
              <mat-icon>article</mat-icon>
              {{ related.title }}
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Footer -->
  <div class="help-footer">
    <span>Need more help?</span>
    <a href="mailto:support@dentassist.com">Contact Support</a>
  </div>
</div>
